<template>
  <div class="layout-main">
    <div class="layout-table-basic">
      <div class="toolbar">
        <div class="search">
          <el-form :inline="true">
            <el-form-item label="金融公司名称 ：">
              <el-input size="small" placeholder="请输入金融公司名称" v-model="filterData.keyword" clearable></el-input>
            </el-form-item>
            <el-form-item label="车辆类型 ：">
              <el-select v-model="filterData.salesType">
                <el-option v-for="item in salesTypeOptions" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结束时间 ：">
              <el-date-picker v-model="filterData.time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="handleSearchReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="handle">
          <el-button size="small" type="primary" @click="handleCreate('form')">添加</el-button>
          <input type="file" hidden ref="import" accept=".xlsx" @change="handleImportSubmit" />
        </div>
      </div>

      <div class="table">
        <el-table v-loading="isTableloading" :data="tableData" stripe highlight-current-row style="width: 100%" height="100%" @row-click="handleDrawerDetailVisible">
          <el-table-column prop="" label="" width="10"> </el-table-column>
          <el-table-column prop="id" label="竞拍ID" width="80"> </el-table-column>
          <el-table-column prop="salesTitle" label="金融公司名称" min-width="100" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="salesNotice" label="拍卖公告" min-width="200" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="salesType" label="车辆类型" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.salesType == 1">过户车</div>
              <div v-if="scope.row.salesType == 2">债权车</div>
            </template>
          </el-table-column>
          <el-table-column prop="carsNum" label="关联车辆" width="100">
            <template slot-scope="scope">
              <el-button @click.native.stop="handleRoute(scope.row.id)" type="text" style="color:#606266">{{ scope.row.carsNum }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="lastTime" label="剩余时间" width="200"></el-table-column>
          <el-table-column prop="salesEndtime" label="截止时间" width="200"></el-table-column>
          <el-table-column label="操作" fixed="right" width="200">
            <template slot-scope="scope">
              <el-button @click.native.stop="handleEdit(scope.row, 'form')" type="text">编辑</el-button>
              |
              <el-button @click.native.stop="handleImport(scope.row)" type="text">导入车辆</el-button>
              |
              <el-popconfirm cancel-button-type="Primary" icon="el-icon-info" icon-color="red" :title="'您确定要删除【' + scope.row.salesTitle + '】记录吗？'" @confirm="handleDeleteConfirm(scope.row)" placement="bottom-end">
                <el-button type="text" slot="reference" @click.native.stop="" style="color:red">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination">
        <el-pagination :page="searchParams.page" :page-size="searchParams.limit" :total="total" background layout="total, sizes, prev, pager, next" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
      </div>

      <!-- 添加、编辑，模态框组件 -->
      <el-dialog :title="dialogTitle" :visible="dialogVisible" @close="dialogVisible = false" width="600px">
        <el-form :model="form" ref="form" label-width="120px">
          <el-form-item label="拍卖名称" prop="salesTitle">
            <el-input v-model="form.salesTitle" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="拍卖公告" prop="salesNotice">
            <el-input v-model="form.salesNotice" placeholder="" type="textarea" :rows="10"></el-input>
          </el-form-item>
          <el-form-item label="截至时间" prop="salesEndtime">
            <el-date-picker v-model="form.salesEndtime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
          </el-form-item>
          <el-form-item label="车辆类型" prop="salesType">
            <el-select v-model="form.salesType">
              <el-option v-for="item in salesTypeOptions" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click="handleSubmit()">保存</el-button>
        </div>
      </el-dialog>

      <!-- 列表详情，抽屉组件 -->
      <el-drawer title="详情" :visible.sync="drawerDetailVisible">
        <div class="layout-drawer-handle">
          <el-button type="primary" size="small" @click="handleEdit(drawerDetailObj, 'form')">编辑</el-button>
          <el-popconfirm cancel-button-type="Primary" icon="el-icon-info" icon-color="red" :title="'您确定要删除【' + drawerDetailObj.salesTitle + '】记录吗？'" @confirm="handleDeleteConfirm(drawerDetailObj)" placement="bottom-end">
            <el-button type="danger" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </div>
        <div class="layout-drawer-detail">
          <div class="layout-drawer-detail-top">
            <div class="layout-drawer-detail-top-title">
              基础信息
            </div>
          </div>
          <div class="layout-drawer-detail-main">
            <div class="layout-drawer-detail-list">
              <DrawerDetail liLabel="拍卖名称" :liValue="drawerDetailObj.salesTitle"></DrawerDetail>
              <DrawerDetail liLabel="拍卖公告" :liValue="drawerDetailObj.salesNotice"></DrawerDetail>
              <DrawerDetail liLabel="车辆类型" :liValue="drawerDetailObj.salesType" :valueArr="this.salesTypeOptions"></DrawerDetail>
              <DrawerDetail liLabel="关联车辆" :liValue="drawerDetailObj.carsNum"></DrawerDetail>
              <DrawerDetail liLabel="截止时间" :liValue="drawerDetailObj.salesEndtime"></DrawerDetail>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
let interval;
import Request from '@/api/sale';

import DrawerDetail from '../../../layout/console/components/DrawerDetail.vue';
export default {
  components: {
    DrawerDetail,
  },

  data() {
    return {
      //列表相关
      tableData: null,
      isTableloading: false,
      total: 0,

      //查询区域字段
      filterData: {
        keyword: '',
        salesType: '',
        time: [],
      },

      salesTypeOptions: [
        { label: '过户车', value: 1 },
        { label: '债权车', value: 2 },
      ],

      //发送查询请求字段
      searchParams: {
        limit: 10,
        page: 1,
      },

      //模态框
      isEdit: false,
      idEdit: '',
      dialogVisible: false,
      dialogTitle: '添加',

      drawerDetailVisible: false,
      drawerDetailObj: {},

      form: {
        salesTitle: '',
        salesNotice: '',
        salesEndtime: '',
        salesType: 1,
      },

      importSaleId: '',
    };
  },

  mounted() {
    this.getTableList();
    this.getLastTime();
  },

  methods: {
    getTableList() {
      this.isTableloading = true;
      Request.page(this.searchParams).then((res) => {
        console.log(res);
        this.isTableloading = false;
        if (res && res.code === 200) {
          if (res.data.list.length > 0) {
            this.renderTable(res.data.list);
          } else {
            if (this.searchParams.page > 1) {
              this.searchParams.page--;
              this.getTableList();
            } else {
              this.renderTable(res.data.list);
            }
          }
          this.total = res.data.total;
        }
      });
    },

    // 渲染表格
    renderTable(data) {
      this.tableData = [];
      data.forEach((e) => {
        e.lastTime = '正在计算';
        this.tableData.push(e);
      });
    },

    //查询搜索按钮
    handleSearch() {
      for (let key in this.filterData) {
        this.searchParams[key] = this.filterData[key];
      }

      this.searchParams.startTime = this.filterData.time[0];
      this.searchParams.endTime = this.filterData.time[1];
      delete this.searchParams.time;

      for (let key in this.searchParams) {
        if (!this.searchParams[key]) {
          delete this.searchParams[key];
        }
      }

      this.searchParams.page = 1;
      this.getTableList();
    },

    //查询重置按钮
    handleSearchReset() {
      for (let key in this.filterData) {
        this.filterData[key] = '';
      }

      this.handleSearch();
    },

    //分页改变每页显示数量
    handleSizeChange(val) {
      this.searchParams.page = 1;
      this.searchParams.limit = val;
      this.getTableList();
    },

    //分页跳转至当前页
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getTableList();
    },

    //添加按钮
    handleCreate(formName) {
      this.isEdit = false;
      this.dialogTitle = '添加';
      this.dialogVisible = true;

      this.$nextTick(() => {
        this.$refs[formName].resetFields();

        for (let key in this.form) {
          this.form[key] = '';
        }
      });
    },

    //列表里操作列编辑按钮
    handleEdit(row, formName) {
      this.isEdit = true;
      this.idEdit = row.id;
      this.dialogTitle = '编辑';
      this.dialogVisible = true;

      this.$nextTick(() => {
        this.$refs[formName].resetFields();

        for (let key in this.form) {
          this.form[key] = row[key];
        }
      });
    },

    //添加、编辑模态框的保存提交按钮
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.form);

          if (!this.isEdit) {
            Request.create(data).then((res) => {
              if (res && res.code === 200) {
                this.msgSuccess('添加成功');
                this.searchParams.page = 1;
                this.getTableList();
              } else {
                this.msgError('添加失败：' + res.msg);
              }
              this.dialogVisible = false;
            });
          } else {
            data.id = this.idEdit;
            Request.update(data).then((res) => {
              if (res && res.code === 200) {
                this.msgSuccess('编辑成功');
                this.getTableList();

                if (this.drawerDetailVisible) this.drawerDetailObj = Object.assign(this.drawerDetailObj, data);
              } else {
                this.msgError('编辑失败：' + res.msg);
              }
              this.dialogVisible = false;
            });
          }
        } else {
          return false;
        }
      });
    },

    //列表里操作列删除按钮弹出提示框的 确定 按钮
    handleDeleteConfirm(row) {
      let loading = this.$loading({ background: 'rgba(0, 0, 0, 0.6)' });

      Request.remove(row.id).then((res) => {
        if (res && res.code == 200) {
          this.msgSuccess('删除成功');
          loading.close();
          this.getTableList();

          if (this.drawerDetailVisible) this.drawerDetailVisible = false;
        }
      });
    },

    //点击列表row右侧弹出详情框
    handleDrawerDetailVisible(row) {
      this.drawerDetailObj = row;
      this.drawerDetailVisible = true;
    },

    //
    handleImport(row) {
      this.importSaleId = row.id;
      this.$refs.import.click();
    },

    handleImportSubmit(e) {
      console.log(e);
      const fileTarget = e.target.files[0];
      const formData = new FormData();
      formData.append('excelFile ', fileTarget);
      formData.append('salesId  ', this.importSaleId);
      Request.import(formData).then((res) => {
        if (res.code === 200) {
          this.$message.success('导入成功');
          this.getTableList();
        } else {
          this.$message.error('导入失败，请检查');
        }
      });
    },

    //
    getLastTime() {
      interval = setInterval(() => {
        for (let i = 0; i < this.tableData.length; i++) {
          let end = new Date(this.tableData[i].salesEndtime).getTime();
          let now = new Date().getTime();
          let value = (end - now) / 1000;

          let time = [],
            day = parseInt(value / 86400),
            hour = parseInt((value % 86400) / 3600),
            min = parseInt(((value % 86400) % 3600) / 60),
            sec = parseInt(((value % 86400) % 3600) % 60);
          time[0] = day > 0 ? this.addZero(day) : this.addZero(0);
          time[1] = hour > 0 ? this.addZero(hour) : this.addZero(0);
          time[2] = min > 0 ? this.addZero(min) : this.addZero(0);
          time[3] = sec > 0 ? this.addZero(sec) : this.addZero(0);

          if (time[0] == '00' && time[1] == '00' && time[2] == '00' && time[3] == '00') {
            this.tableData[i].lastTime = '已截止';
          } else {
            this.tableData[i].lastTime = time[0] + '天' + time[1] + '小时' + time[2] + '分' + time[3] + '秒';
          }
        }
      }, 333);
    },

    addZero(num) {
      return num < 10 ? '0' + num : num;
    },

    handleRoute(id) {
      this.$router.push({
        path: '/console/car/car',
        query: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scope></style>
